'use strict';

/**
 * @description Initialize event handlers on landing page
 */

window.addEventListener('mainJsLoaded', function () {
    kidsInit();
});

function kidsInit() {
    // FEATURE 1 - Animations
    kidsAnimationsInit();

    // FEATURE 2 - Mobile carousel tiggers
    kidsMobileCarouselsInit();

    // FEATURE 3 - Desktop custom tiggers
    kidsDesktopCustomTiggersInit();
}

/* FEATURE 1 - Animations */
function kidsAnimationsInit() {
    var prevTopScroll = 0,
        $kidsAnimation1 = $('.js-kids-animation-1'),
        kidsAnimation1Offset = 0,
        $kidsAnimation1Bottom = $('.js-kids-animation-1-bottom'),
        kidsAnimation1BottomOffset = 0,
        $kidsAnimation2 = $('.js-kids-animation-2'),
        kidsAnimation2Offset = 0,
        $kidsAnchors = $('.js-kids-anchor');

    window.addEventListener('scroll', function () {
        // desktop animation only
        if (window.vbqUtils.breakpoint.is('fromDesktop')) {
            var currentTopScroll = window.pageYOffset,
                currentScroll = currentTopScroll / window.innerHeight;

            if ($kidsAnimation1.length) {
                kidsAnimation1Offset = $kidsAnimation1.offset().top / window.innerHeight;
                document.body.style.setProperty('--scrolloffset1', kidsAnimation1Offset);
            }

            // for activation of fixed position on animation 1 if custom anchors reset it
            if ($kidsAnimation1Bottom.length) {
                kidsAnimation1BottomOffset = $kidsAnimation1Bottom.offset().top / window.innerHeight;
            }

            if ($kidsAnimation2.length) {
                kidsAnimation2Offset = $kidsAnimation2.offset().top / window.innerHeight;
                document.body.style.setProperty('--scrolloffset2', kidsAnimation2Offset);
            }

            document.body.style.setProperty('--scroll', currentScroll);

            // scroll down
            if (currentTopScroll > prevTopScroll) {
                // activate fixed position on animation 1
                if (currentScroll >= kidsAnimation1Offset && !$kidsAnimation1.hasClass('stop-animation')) {
                    $kidsAnimation1.addClass('animate');
                }

                // activate fixed position on animation 2
                if (currentScroll >= kidsAnimation2Offset) {
                    $kidsAnimation2.addClass('animate');
                }

                // activate bottom position on animation 2 - stop phase ( + 1 viewports)
                if (currentScroll >= kidsAnimation2Offset + 1) {
                    $kidsAnimation2.addClass('bottom').removeClass('animate');
                }
            } else {
            // scroll up
                // activate fixed position on animation 2 ( + 1 viewports)
                if (currentScroll < kidsAnimation2Offset + 1) {
                    $kidsAnimation2.addClass('animate').removeClass('bottom');
                }

                // deactivate fixed position on animation 2
                if (currentScroll < kidsAnimation2Offset) {
                    $kidsAnimation2.removeClass('animate');
                }

                // activate fixed position on animation 1 if custom anchors reset it
                if (currentScroll < kidsAnimation1BottomOffset) {
                    $kidsAnimation1.addClass('animate').removeClass('stop-animation');
                }

                // deactivate fixed position on animation 1
                if (currentScroll < kidsAnimation1Offset) {
                    $kidsAnimation1.removeClass('animate');
                }
            }

            // update prevTopScroll
            prevTopScroll = currentTopScroll;
        }
    }, false);

    // activate custom anchors to fix issue with animation scroll
    $kidsAnchors.on('click keydown', function (e) {
        // mouse click or enter/space key
        if (e.type == 'click' || (e.type == 'keydown' && (e.keyCode == 13 || e.keyCode == 32))) {
            // prevent the default action to stop scrolling when space is pressed
            e.preventDefault();

            var $control = $(this),
                $target = $($control.attr('href'));

            // deactivate animation for proper top scroll position
            $kidsAnimation1.addClass('stop-animation').removeClass('animate');

            window.vbqUtils.cache.$html.animate({
                scrollTop: $target.offset().top
            }, 10);
        }
    });

    // remove desktop animations
    window.vbqUtils.breakpoint.set([
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('mobileAndTablet'),
            enter: function () {
                $kidsAnimation1.removeClass('animate').addClass('stop-animation');
                $kidsAnimation2.removeClass('animate').removeClass('bottom');
            }
        }
    ]);
}

/* FEATURE 2 - Mobile carousel tiggers */
function kidsMobileCarouselsInit() {
    var $kidsMobileLifestyleCarousels = $('.js-mobile-lifestyle-carousel'),
        $allKidsMobileLifestyleControls = $('.js-mobile-lifestyle-control');

    // sync triggers with carousel state
    $kidsMobileLifestyleCarousels.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var $this = $(this),
            $controls = $this.next('.js-mobile-lifestyle-nav').find('.js-mobile-lifestyle-control');

        $controls.removeClass('active').filter('[data-index="' + nextSlide + '"]').addClass('active');
    });

    // setup mobile lifestyle carousel
    window.vbqUtils.breakpoint.set([
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('mobile'),
            enter: function () {
                $kidsMobileLifestyleCarousels.slick({
                    slidesToShow: 1,
                    dots: false,
                    arrows: false,
                    infinite: false
                });

                $kidsMobileLifestyleCarousels.each(function () {
                    var $carousel = $(this),
                        $controls = $carousel.next('.js-mobile-lifestyle-nav').find('.js-mobile-lifestyle-control');

                    $controls.first().addClass('active') ;
                });
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('tabletAndDesktop'),
            enter: function () {
                if ($kidsMobileLifestyleCarousels.hasClass('slick-initialized')) {
                    $kidsMobileLifestyleCarousels.slick('unslick');
                }

                $allKidsMobileLifestyleControls.removeClass('active');
            }
        }
    ]);

    $allKidsMobileLifestyleControls.on('click keydown', function (e) {
        // mouse click or enter key
        if (e.type == 'click' || (e.type == 'keydown' && e.keyCode == 13)) {
            var $control = $(this),
                $nav = $control.parent('.js-mobile-lifestyle-nav'),
                $controls = $nav.find('.js-mobile-lifestyle-control'),
                $carousel = $nav.prev('.js-mobile-lifestyle-carousel');

            if (window.vbqUtils.breakpoint.is('mobile')) {
                if ($carousel.hasClass('slick-initialized')) {
                    $controls.removeClass('active');
                    $carousel.slick('slickGoTo', $control.data('index'));
                    $control.addClass('active');
                }
            }
        }
    });
}

/* FEATURE 3 - Desktop custom tiggers */
function kidsDesktopCustomTiggersInit() {
    var $kidsDesktopCustomCarousels = $('.js-desktop-custom-carousel'),
        $kidsDesktopCustomControls = $('.js-desktop-custom-control');

    // 2 sections: section 4 & section 6
    $kidsDesktopCustomCarousels.each(function () {
        var $carousel = $(this),
            // carousel-index = 0 - section 4 & carousel-index = 1 - section 6
            carouselIndex = $carousel.data('carousel-index');

        document.body.style.setProperty('--customIndex' + carouselIndex, 0);
    });

    // adjust css vars on scroll / resize to calculate accurately on lazyloaded images
    window.addEventListener('scroll', function () {
        if (window.vbqUtils.breakpoint.is('tabletAndDesktop')) {
            $kidsDesktopCustomCarousels.each(function () {
                var $carousel = $(this),
                    // carousel-index = 0 - section 4 & carousel-index = 1 - section 6
                    carouselIndex = $carousel.data('carousel-index'),
                    $controls =  $carousel.find('.js-desktop-custom-control'),
                    $images = $carousel.find('.js-desktop-custom-carousel-image'),
                    customBgHeight = $images.first().height(),
                    $products = $carousel.find('.js-desktop-custom-carousel-product'),
                    customProductHeight = $products.first().outerHeight();

                // adjust transition height
                document.body.style.setProperty('--customBgHeight' + carouselIndex, customBgHeight);
                document.body.style.setProperty('--customBgHeightPx' + carouselIndex, customBgHeight + 'px');
                document.body.style.setProperty('--customHeightPx' + carouselIndex, customBgHeight * $controls.length + 'px');

                // adjust product transition height
                document.body.style.setProperty('--customProductHeight' + carouselIndex, customProductHeight);
                document.body.style.setProperty('--customProductHeightPx' + carouselIndex, customProductHeight + 'px');
                document.body.style.setProperty('--customTotalProductHeightPx' + carouselIndex, customProductHeight * $controls.length + 'px');
            });
        }
    });

    // sync tabs & block state
    $kidsDesktopCustomControls.on('click keydown', function (e) {
        // mouse click or enter key
        if (e.type == 'click' || (e.type == 'keydown' && e.keyCode == 13)) {

            if (window.vbqUtils.breakpoint.is('tabletAndDesktop')) {
                var $this = $(this),
                    index = $this.data('index'),
                    carouselIndex = $this.data('carousel-index'),
                    $groupControls = $kidsDesktopCustomControls.filter('[data-carousel-index="' + carouselIndex + '"]'),
                    $groupCarousel = $kidsDesktopCustomCarousels.filter('[data-carousel-index="' + carouselIndex + '"]'),
                    $productLinks = $groupCarousel.find('.js-desktop-custom-carousel-product-link');

                // trigger slide transition
                document.body.style.setProperty('--customIndex' + carouselIndex, index);

                $groupControls.removeClass('active').filter('[data-index="' + index + '"]').addClass('active');

                // change product link accessibility
                $productLinks.attr('tabindex', '-1').filter('[data-index="' + index + '"]').attr('tabindex', '0');
            }
        }
    });

    // reset desktop custom tiggers
    window.vbqUtils.breakpoint.set([
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('mobile'),
            enter: function () {
                $kidsDesktopCustomCarousels.each(function () {
                    var $carousel = $(this),
                        // carousel-index = 0 - section 4 & carousel-index = 1 - section 6
                        carouselIndex = $carousel.data('carousel-index'),
                        $controls = $carousel.find('.js-desktop-custom-control'),
                        $productLinks = $carousel.find('.js-desktop-custom-carousel-product-link');

                    $controls.removeClass('active').first().addClass('active');
                    $productLinks.attr('tabindex', '-1').first().attr('tabindex', '0');

                    // stop slide transition
                    document.body.style.setProperty('--customIndex' + carouselIndex, 0);
                });
            }
        }
    ]);
}
